import { ArrowForwardIos } from "@mui/icons-material";
import { Button, Divider, Typography } from "@mui/material";
import { useState } from "react";

import CustomIconButton from "../../../ui library/components/buttons/CustomIconButton";
import Svg, { SvgEnum } from "../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../ui library/HNSColors";

const CaseListFilter = ({ children }) => {
  const [openFilter, setOpenFilter] = useState(false);

  return (
    <>
      <Button
        sx={{
          background: HNSColors.secondary[500],
          "&:hover": { background: HNSColors.secondary[600] },
        }}
        className="flex items-center gap-2 px-4 py-2 text-sm normal-case transition rounded-full"
        variant="contained"
        disableElevation
        onClick={() => setOpenFilter(true)}
        type="button"
      >
        <Svg name={SvgEnum.HisFilters} />
        Filter Cases
      </Button>

      <aside
        role="dialog"
        aria-label="Filter panel"
        className={`absolute top-0 z-[1000] flex h-screen w-[450px] transform flex-col rounded-bl-[10px] rounded-tl-[10px] border-r border-[#ececec] bg-white shadow-[4px_0_6px_-2px_rgba(0,0,0,0.2)] transition-transform duration-300 ease-out will-change-transform ${openFilter ? "left-0 translate-x-0" : "-left-10 -translate-x-full"} `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <Typography className="p-2 pl-4 text-lg font-bold">Filter Clients:</Typography>
          <CustomIconButton
            tooltipText="Hide Filter Menu"
            classes="rotate-180 p-2"
            handleOnClick={() => setOpenFilter(false)}
            iconVisible={true}
            CustomIcon={<ArrowForwardIos className="text-sky-600" />}
          />
        </div>
        <Divider />
        {children}
      </aside>
    </>
  );
};

export default CaseListFilter;
